<div class="uploaded-invoice-document-item-parent" >
  <div class="filename">
    <span [pTooltip]="file.name" tooltipPosition="left">{{file.name}}</span>
  </div>
  <div class="delete-button-wrapper">
    <button type="button" pButton icon="fa fa-trash-o fa-lg" (click)="deleteFile()"></button>
  </div>
</div>
